import PropTypes from 'prop-types';

export default PropTypes.shape({
	ConversionName: PropTypes.string,
	CreatorPartnerID: PropTypes.string,
	CreateDate: PropTypes.instanceOf(Date),
	DeleteDate: PropTypes.instanceOf(Date),
	Duration: PropTypes.number,
	EmailBody: PropTypes.string,
	ExpireDate: PropTypes.instanceOf(Date),
	ExternalMediaID: PropTypes.string,
	FileName: PropTypes.string,
	HeaderOption: PropTypes.number,
	HeaderGraphic: PropTypes.string,
	HeaderGraphicUrl: PropTypes.string,
	Label: PropTypes.string,
	MediaID: PropTypes.number,
	ModifyDate: PropTypes.instanceOf(Date),
	PosterSeconds: PropTypes.number,
	SourceContentUrl: PropTypes.string,
	SourceContentImage:  PropTypes.string,
	Subject:  PropTypes.string,
	ThumbnailLink:  PropTypes.string,
	Version: PropTypes.number,
	isProcessing: PropTypes.bool
});